<template>
  <span>{{ label }}</span>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    label() {
      const parts = [];
      if (this.item.responsible && this.item.responsible.name) {
        parts.push(this.item.responsible.name);
      }
      if (this.item.responsibleText) parts.push(this.item.responsibleText);
      return parts.length ? parts.join(" / ") : "-";
    },
  },
};
</script>
